import { AddressFormularController } from './addressFormular.controller';
import template from './addressFormular.html';

export const addressFormularComponent = {
  name: 'addressFormular',
  restrict: 'E',
  template,
  controller: AddressFormularController,
  controllerAs: 'vm',
  bindings: {
    form: '=',
    model: '<',
    onSubmit: '&',
    reset: '&',
    hideButtons: '<?'
  }
};
